class OkartCarousel {
  constructor(section) {
    this.section = section
    this.container = this.section.querySelector('.okart-carousel-container')
    this.swiperEl = this.container.querySelector('.okart-swiper')
    if (!this.swiperEl) return
    this.init()
    this.fixIOSSingleTap()
  }

  init() {
    const slidesDesktop = parseInt(this.swiperEl.dataset.slidesDesktop, 10) || 4
    const slidesMobile = parseInt(this.swiperEl.dataset.slidesMobile, 10) || 2
    const autoplayEnabled = this.swiperEl.dataset.autoplay === "true"
    /* "delay" setting now controls marquee speed (transition duration in ms).
       Lower = faster scroll. Default 4500ms per slide for elegant slow drift. */
    const marqueeSpeed = parseInt(this.swiperEl.dataset.delay, 10) || 4500

    const config = {
      loop: true,
      slidesPerView: slidesMobile,
      spaceBetween: 6,
      observer: true,
      observeParents: true,
      grabCursor: true,
      threshold: 15,
      touchAngle: 25,
      touchStartPreventDefault: false,
      touchReleaseOnEdges: true,
      passiveListeners: true,
      navigation: {
        nextEl: this.container.querySelector('.okart-swiper-button-next'),
        prevEl: this.container.querySelector('.okart-swiper-button-prev')
      },
      breakpoints: {
        769: {
          slidesPerView: slidesDesktop,
          spaceBetween: 20,
          grabCursor: true,
          allowTouchMove: true
        }
      },
      on: {
        init: () => this.section.classList.add('is-initialized')
      }
    }

    /* CONTINUOUS MARQUEE-STYLE AUTOPLAY:
       delay: 0 + waitForTransition: false + speed: marqueeSpeed
       creates smooth continuous drift instead of stepped advance.
       Pauses on hover (desktop) and on touch (mobile). */
    if (autoplayEnabled) {
      config.autoplay = {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        waitForTransition: false,
        reverseDirection: false
      }
      config.speed = marqueeSpeed
      config.allowTouchMove = true
      config.freeMode = false
    }

    this.swiper = new Swiper(this.swiperEl, config)

    /* Mobile touch pause — Swiper's pauseOnMouseEnter doesn't fire on touch */
    if (autoplayEnabled && this.swiper && this.swiper.autoplay) {
      const pauseAutoplay = () => {
        try { this.swiper.autoplay.pause() } catch(e) {}
      }
      const resumeAutoplay = () => {
        /* Brief delay so user finishes their swipe before resuming */
        setTimeout(() => {
          try { this.swiper.autoplay.resume() } catch(e) {}
        }, 800)
      }

      this.swiperEl.addEventListener('touchstart', pauseAutoplay, { passive: true })
      this.swiperEl.addEventListener('touchend', resumeAutoplay, { passive: true })
      this.swiperEl.addEventListener('touchcancel', resumeAutoplay, { passive: true })

      /* Pause when section scrolls offscreen (perf optimization) */
      if ('IntersectionObserver' in window) {
        const obs = new IntersectionObserver(entries => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              try { this.swiper.autoplay.start() } catch(_) {}
            } else {
              try { this.swiper.autoplay.stop() } catch(_) {}
            }
          })
        }, { threshold: 0.1 })
        obs.observe(this.section)
      }
    }
  }

  fixIOSSingleTap() {
    const cards = this.swiperEl.querySelectorAll('a.okart-card')
    cards.forEach(card => {
      card.addEventListener('touchend', e => {
        const now = Date.now()
        const last = parseInt(card.dataset.lastTap || 0)
        if (now - last < 400) {
          window.location = card.href
          e.preventDefault()
        }
        card.dataset.lastTap = now
      }, { passive: true })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.okart-section').forEach(s => new OkartCarousel(s))
})
document.addEventListener('shopify:section:load', e => {
  const s = e.target.closest('.okart-section')
  if (s && !s.classList.contains('is-initialized')) new OkartCarousel(s)
})
